import { supabase } from "./supabase";

export interface AuditEntry {
  action: string;
  entityType: "news" | "content" | "user" | "account";
  entityId?: string | null;
  entityTitle: string;
  details?: Record<string, unknown>;
}

export async function writeAuditLog(entry: AuditEntry): Promise<void> {
  const { error } = await supabase.rpc("write_admin_audit_log", {
    p_action: entry.action,
    p_entity_type: entry.entityType,
    p_entity_id: entry.entityId || null,
    p_entity_title: entry.entityTitle,
    p_details: entry.details || {},
  });

  if (error) console.error("Audit log could not be written", error);
}
